import { render, staticRenderFns } from "./surplusMaterialStorageCode.vue?vue&type=template&id=4c712e4c&scoped=true&"
import script from "./surplusMaterialStorageCode.vue?vue&type=script&lang=js&"
export * from "./surplusMaterialStorageCode.vue?vue&type=script&lang=js&"
import style0 from "./surplusMaterialStorageCode.vue?vue&type=style&index=0&id=4c712e4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c712e4c",
  null
  
)

export default component.exports